import React from 'react'
import { SuccessStyle, SuccessStyleInner } from '../styles'

export default ({children}) => (
  <div className={SuccessStyle}>
    <p className={SuccessStyleInner}>{children}</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Success.js